// import React from "react";
// import { Link } from "react-router-dom";

// function SubNav(props) {
//   return (
//     <Link
//       className="subNav btn shadow-sm mx-2 mb-2 d-inline-flex align-items-center"
//       to={props.url}
//     >
//       <span className="material-symbols-outlined me-2">{props.icon}</span>
//       <span>{props.title}</span>
//     </Link>
//   );
// }

// export default SubNav;

import React from "react";
import { Link } from "react-router-dom";

function SubNav(props) {
  return (
    <Link
      className="subNav btn btn-light shadow-sm mx-2 mb-2 d-inline-flex align-items-center position-relative overflow-hidden border-0"
      to={props.url}
      style={{
        padding: "0.75rem 1.25rem",
        borderRadius: "12px",
        transition: "all 0.3s ease",
        background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
      }}
    >
      {/* Icon with gradient background */}
      <span
        className="material-symbols-outlined me-3 d-flex align-items-center justify-content-center rounded-3"
        style={{
          width: "36px",
          height: "36px",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          fontSize: "20px",
          transition: "transform 0.3s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        {props.icon}
      </span>

      {/* Title text */}
      <span
        className="fw-medium"
        style={{
          color: "#2d3748",
          fontSize: "0.95rem",
        }}
      >
        {props.title}
      </span>
    </Link>
  );
}

export default SubNav;
